import React from 'react';
import styled from 'styled-components';

import Loader from '../Loader';
import { StyledButton, StyleProps } from './style';

interface IButtonProps
  extends React.ComponentPropsWithoutRef<'button'>,
  StyleProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  htmlType?: 'submit' | 'reset' | 'button';
  bgColor?: string;
  outline?: boolean;
}

const Button = ({
  children,
  variant,
  size,
  bgColor,
  color,
  isLoading = false,
  isDisabled = false,
  width,
  outline,
  htmlType = 'button',
  ...restProps
}: IButtonProps) => {
  const loaderColor = outline ? color : 'white';

  return (
    <StyledButton
      size={size}
      variant={variant}
      $bgColor={bgColor}
      disabled={isDisabled}
      color={color}
      width={width}
      $outline={outline}
      type={htmlType}
      {...restProps}
    >
      {isLoading ? (
        <Loader color={loaderColor} type="spinner" size={'xsm'} />
      ) : (
        <>{children}</>
      )}
    </StyledButton>
  );
};

Button.defaultProps = {
  variant: 'primary',
  size: 'md',
  bgColor: '',
  outline: false,
  color: '',
  width: 'fit-content',
};

export default Button;

export const FilterButton = styled(Button)`
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.normalText};
  border-radius: 6px;
  border-color: ${({ theme }) => theme.colors.disableText};
  border-width: 0.5px;
`;
